import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bb102c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-between mb-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-bold" }, "Agency Edit Product Catalog", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-copy" }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("  Duplicate Catalog ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("  Save ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Information")
], -1))
const _hoisted_8 = { class: "px-10 pt-0" }
const _hoisted_9 = { class: "pt-0" }
const _hoisted_10 = { class: "pt-0" }
const _hoisted_11 = { class: "flex items-center pt-0" }
const _hoisted_12 = { class: "pt-0" }
const _hoisted_13 = { class: "pt-0" }
const _hoisted_14 = { class: "pt-0" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Variants")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Artwork Template")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mockup")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Fulfillment")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center ml-3 text-gray-600 w-35" }, " Processing time (days) ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Production")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Shipping")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center ml-3 text-gray-600 w-35" }, " Shipping time (days) ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Material")
], -1))
const _hoisted_24 = { class: "flex items-center justify-between mt-3" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode("  Save ")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-center" }, "Confirm", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Are you sure you want to delete catalog ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_33 = { class: "dialog-footer" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_35 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("  Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_RefreshLeft = _resolveComponent("RefreshLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_Variants = _resolveComponent("Variants")!
  const _component_DesignTemplate = _resolveComponent("DesignTemplate")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_sectionLayoutContent = _resolveComponent("sectionLayoutContent")!

  return (_openBlock(), _createBlock(_component_sectionLayoutContent, _mergeProps(_ctx.content, {
    backPageTitle: `Back`,
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { class: "create-catalog" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", null, [
                  (_ctx.allowCreateCatalog)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: _ctx.cloneCatalog
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _hoisted_4
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.updateCatalog
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _hoisted_6
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_skeleton)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            class: "create-catalog"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { md: 18 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_card, { class: "my-3" }, {
                            header: _withCtx(() => [
                              _hoisted_7
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_8, [
                                _createVNode(_component_el_form, {
                                  model: _ctx.catalog,
                                  rules: _ctx.rulesCatalog,
                                  ref: "catalogFormUpdate",
                                  "label-width": "15%"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "name",
                                      label: "Name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_9, [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.catalog.name,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.catalog.name) = $event)),
                                            placeholder: "Name"
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "category",
                                      label: "Category"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          class: "w-full",
                                          multiple: "",
                                          filterable: "",
                                          modelValue: _ctx.catalog.categories,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.catalog.categories) = $event)),
                                          placeholder: "Please select a category"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: `category-${item._id}`,
                                                label: item.title,
                                                value: item._id,
                                                size: 25
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "productCode",
                                      label: "Code"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_10, [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.catalog.productCode,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.catalog.productCode) = $event)),
                                            placeholder: "Code"
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "",
                                      label: "Display price ($)"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_11, [
                                          _createVNode(_component_el_input_number, {
                                            modelValue: _ctx.catalog.displayPrice,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.catalog.displayPrice) = $event)),
                                            placeholder: "Display price",
                                            controls: false
                                          }, null, 8, ["modelValue"]),
                                          _createVNode(_component_el_button, {
                                            type: "text",
                                            class: "mx-3",
                                            title: "Get min price",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (
                          _ctx.catalog.displayPrice = _ctx.catalog?.variants
                            ? Math.min(
                                ..._ctx.catalog.variants.map(
                                  variant => variant?.cost || 0
                                )
                              )
                            : 0
                        ))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_RefreshLeft)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "",
                                      label: "Catalog type"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createVNode(_component_el_select, {
                                            clearable: "",
                                            modelValue: _ctx.catalog.type,
                                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.catalog.type) = $event)),
                                            placeholder: "Type"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                            { label: 'POD', value: 'pod' },
                            { label: 'DROP', value: 'drop' },
                            { label: 'FK', value: 'fake' },
                          ], (item) => {
                                                return _createVNode(_component_el_option, {
                                                  key: item.value,
                                                  placeholder: "Type",
                                                  label: item.label,
                                                  value: item.value
                                                }, null, 8, ["label", "value"])
                                              }), 64))
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "designAndTemplateUrl",
                                      label: "Mockup & Template"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_13, [
                                          _createVNode(_component_el_input, {
                                            modelValue: _ctx.catalog.designAndTemplateUrl,
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.catalog.designAndTemplateUrl) = $event)),
                                            placeholder: "Mockup & Template URL"
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_form_item, {
                                      class: "font-bold",
                                      prop: "status",
                                      label: "Status"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_14, [
                                          _createVNode(_component_el_switch, {
                                            modelValue: _ctx.catalog.status,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.catalog.status) = $event))
                                          }, null, 8, ["modelValue"])
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_tabs, {
                                      modelValue: _ctx.activeName,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.activeName) = $event)),
                                      class: "demo-tabs",
                                      onTabClick: _ctx.handleClick
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_tab_pane, {
                                          label: "OVERVIEW",
                                          name: "description",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.description,
                                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.catalog.description) = $event)),
                                                    onCallback: _ctx.changeDescription
                                                  }, null, 8, ["modelValue", "onCallback"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "FEATURE",
                                          name: "description2",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.description2,
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.catalog.description2) = $event)),
                                                    onCallback: _ctx.changeDescription2
                                                  }, null, 8, ["modelValue", "onCallback"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "SIZE GUIDE",
                                          name: "sizeGuide",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.sizeGuide,
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.catalog.sizeGuide) = $event)),
                                                    onCallback: _ctx.changeSizeGuide
                                                  }, null, 8, ["modelValue", "onCallback"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "FULFILLMENT PRICE",
                                          name: "shippingDetail",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.shippingDetail,
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.catalog.shippingDetail) = $event)),
                                                    onCallback: _ctx.changeShippingDetail
                                                  }, null, 8, ["modelValue", "onCallback"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "PRINT FILES GUIDE",
                                          name: "printGuide",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.printGuide,
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.catalog.printGuide) = $event)),
                                                    onCallback: _ctx.changePrintGuide
                                                  }, null, 8, ["modelValue", "onCallback"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_tab_pane, {
                                          label: "CARE INSTRUCTIONS",
                                          name: "service",
                                          lazy: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { class: "font-bold" }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_Editor, {
                                                    modelValue: _ctx.catalog.service,
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.catalog.service) = $event)),
                                                    onCallback: _ctx.changeService
                                                  }, null, 8, ["modelValue", "onCallback"])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onTabClick"])
                                  ]),
                                  _: 1
                                }, 8, ["model", "rules"])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, { class: "my-3" }, {
                            header: _withCtx(() => [
                              _hoisted_15
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_Variants, {
                                onChangeCostBy: _ctx.changeCostBy,
                                onCallback: _ctx.callbackVariant,
                                colors: _ctx.catalog.colors,
                                sizes: _ctx.catalog.sizes,
                                costBy: _ctx.costBy,
                                values: _ctx.catalog.variants,
                                designs: _ctx.catalog.designs,
                                productCode: _ctx.catalog.productCode,
                                isDropShip: _ctx.catalog.dropship || false,
                                typeAction: "view",
                                catalogId: _ctx.catalog._id
                              }, null, 8, ["onChangeCostBy", "onCallback", "colors", "sizes", "costBy", "values", "designs", "productCode", "isDropShip", "catalogId"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_card, null, {
                            header: _withCtx(() => [
                              _hoisted_16
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_DesignTemplate, {
                                dataSet: _ctx.catalog.designs,
                                onCallback: _ctx.addDesign,
                                onDelDesign: _ctx.delDesign
                              }, null, 8, ["dataSet", "onCallback", "onDelDesign"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 6,
                class: "pl-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, { class: "my-3" }, {
                    header: _withCtx(() => [
                      _hoisted_17
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_UploadImage, {
                          accept: `image/*`,
                          multiple: true,
                          title: ``,
                          setData: _ctx.catalog,
                          data: _ctx.catalog.mockupGallery,
                          onCallback: _ctx.callbackMockup
                        }, null, 8, ["setData", "data", "onCallback"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "my-3" }, {
                    header: _withCtx(() => [
                      _hoisted_18
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_form, {
                        model: _ctx.catalog,
                        rules: _ctx.rulesCatalog,
                        ref: "catalogFormUpdate",
                        "label-width": "15%"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            class: "font-bold",
                            prop: "fulfillmentPartner"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-full",
                                multiple: "",
                                filterable: "",
                                modelValue: _ctx.catalog.fulfillmentPartner,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.catalog.fulfillmentPartner) = $event)),
                                placeholder: "Partner"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.partners, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item._id,
                                      label: item.name,
                                      value: item._id,
                                      size: 25
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "font-bold",
                            prop: "fulfillmentLocation"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-full",
                                multiple: "",
                                filterable: "",
                                modelValue: _ctx.catalog.fulfillmentLocation,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.catalog.fulfillmentLocation) = $event)),
                                placeholder: "Location"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.locations, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item._id,
                                      label: item.name,
                                      value: item._id,
                                      size: 25
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "font-bold",
                            prop: "fulfillmentPrintArea"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-full",
                                multiple: "",
                                filterable: "",
                                modelValue: _ctx.catalog.fulfillmentPrintArea,
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.catalog.fulfillmentPrintArea) = $event)),
                                placeholder: "Print areas"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.printAreas, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item._id,
                                      label: item.name,
                                      value: item._id,
                                      size: 25
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            class: "font-bold",
                            prop: "fulfillmentTechniques"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-full",
                                multiple: "",
                                filterable: "",
                                modelValue: _ctx.catalog.fulfillmentTechniques,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.catalog.fulfillmentTechniques) = $event)),
                                placeholder: "Techniques"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.techniques, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item._id,
                                      label: item.name,
                                      value: item._id,
                                      size: 25
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model", "rules"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "my-3" }, {
                    header: _withCtx(() => [
                      _hoisted_20
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_19,
                          _createVNode(_component_el_input, {
                            class: "m-2 w-50",
                            modelValue: _ctx.catalog.processingTime,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.catalog.processingTime) = $event)),
                            modelModifiers: { number: true },
                            type: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Editor, {
                        modelValue: _ctx.catalog.production,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.catalog.production) = $event)),
                        onCallback: _ctx.changeProduction
                      }, null, 8, ["modelValue", "onCallback"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "my-3" }, {
                    header: _withCtx(() => [
                      _hoisted_21
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { gutter: 20 }, {
                        default: _withCtx(() => [
                          _hoisted_22,
                          _createVNode(_component_el_input, {
                            class: "m-2 w-50",
                            modelValue: _ctx.catalog.shippingTime,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.catalog.shippingTime) = $event)),
                            modelModifiers: { number: true },
                            type: "number"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Editor, {
                        modelValue: _ctx.catalog.shipping,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.catalog.shipping) = $event)),
                        onCallback: _ctx.changeShipping
                      }, null, 8, ["modelValue", "onCallback"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "my-3" }, {
                    header: _withCtx(() => [
                      _hoisted_23
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Editor, {
                        modelValue: _ctx.catalog.material,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.catalog.material) = $event)),
                        onCallback: _ctx.changeMaterial
                      }, null, 8, ["modelValue", "onCallback"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", null, [
                      _createVNode(_component_el_button, { onClick: _ctx.discard }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _hoisted_27
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: _ctx.updateCatalog
                      }, {
                        default: _withCtx(() => [
                          _hoisted_28,
                          _hoisted_29
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_dialog, {
                modelValue: _ctx.dialog,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dialog) = $event)),
                width: "40%"
              }, {
                title: _withCtx(() => [
                  _hoisted_30
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("span", _hoisted_33, [
                    _createVNode(_component_el_button, { onClick: _ctx.cancelDelete }, {
                      default: _withCtx(() => [
                        _hoisted_34,
                        _hoisted_35
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.confirmDelete
                    }, {
                      default: _withCtx(() => [
                        _hoisted_36,
                        _hoisted_37
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _hoisted_31,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.catalog.name), 1),
                    _hoisted_32
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 16))
}